<template>
  <div id="AlertMessage" class="alert-modal">
    <div class="alert-dialog">
      <div class="alert-content">
        <slot name="title"></slot>
        <slot name="text"></slot>
        <button @click="clickConfirm" class="btn btn-primario py-3">OK</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    clickConfirm() {
      this.$emit("alertToggle");
    },
  },
};
</script>

<style scoped>
.alert-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  z-index: 1100;
}
.alert-content {
  max-width: 400px;
}
.title-alert {
  font-weight: 700;
  font-size: 1.56rem;
  font-family: "Montserrat", sans-serif;
  margin-bottom: 10px;
}
.text-alert {
  font-family: "Open Sans", sans-serif;
}
.button-alert {
  font-family: "Open Sans", sans-serif;
}
</style>


// WEBPACK FOOTER //
// src/components/organisms/AlertMessage.vue